import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, ModalController, NavParams, ViewController } from 'ionic-angular';
import { AlertMessager } from '../../lib/alertMessager';
import { HorseBreeder } from '../../model/horseBreeder';
import { HorseOwner } from '../../model/horseOwner';
import { HorseService } from '../../services/horse.service';


@Component({
    selector: 'app-horses-add-entity',
    templateUrl: './horses-add-entity.component.html'
})
export class HorsesAddEntityComponent implements OnInit {
    @Input() horseOwner?: HorseOwner;
    @Input() horseBreeder?: HorseBreeder;

    profileForm: FormGroup;
    submitAttempt: boolean;
    dataLoaded: boolean;

    validationMessages: any[] = [];

    constructor(
        private formBuilder: FormBuilder,
        private horseService: HorseService,
        private viewController: ViewController,
        private alert: AlertMessager,
        private modal: ModalController,
        private navParams: NavParams,
        private loadingController: LoadingController) { }

    ngOnInit() {
        this.horseOwner = this.navParams.get('horseOwner');
        this.horseBreeder = this.navParams.get('horseBreeder');
        this.initForm();
    }

    async save() {
        this.submitAttempt = true;

        if (this.profileForm.valid) {
            const loading = await this.loadingController.create({
                content: 'Saving...',
            });

            loading.present();

            try {
                if (this.horseBreeder) {
                    let returnData = null;

                    if (this.horseBreeder.id) {
                        returnData = await this.horseService.updateHorseBreeder(this.horseBreeder)
                    } else {
                        returnData = await this.horseService.addHorseBreeder(this.horseBreeder)
                    }
                } else if (this.horseOwner) {
                    let returnData = null;

                    if (this.horseOwner.id) {
                        returnData = await this.horseService.updateHorseOwner(this.horseOwner)
                    } else {
                        returnData = await this.horseService.addHorseOwner(this.horseOwner)
                    }
                }
            }
            catch (err) {
                this.alert.showError("Error Saving", "Please try again later.");
            }
            finally {
                loading.dismiss();
            }

            this.close(this.profileForm.value);
        }
    }

    close(data) {
        this.viewController.dismiss(data);
    }

    initForm() {
        this.profileForm = this.formBuilder.group({
            emailAddress: [
                this.horseOwner ? this.horseOwner.emailAddress : this.horseBreeder.emailAddress,
                [
                    Validators.required,
                    Validators.pattern('^[a-zA-Z0-9._]+[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$')
                ]
            ],
            name: [this.horseOwner ? this.horseOwner.name : this.horseBreeder.name, [Validators.required]],
            phone: [this.horseOwner ? this.horseOwner.phone : this.horseBreeder.phone, Validators.required],
            address: [this.horseOwner ? this.horseOwner.address : this.horseBreeder.address, Validators.required],
            city: [this.horseOwner ? this.horseOwner.city : this.horseBreeder.city, Validators.required],
            state: [this.horseOwner ? this.horseOwner.state : this.horseBreeder.state, Validators.required],
            zip: [this.horseOwner ? this.horseOwner.zip : this.horseBreeder.zip, Validators.required],
            country: [this.horseOwner ? this.horseOwner.country : this.horseBreeder.country, Validators.required]
        });

        this.validationMessages = [
            { name: 'emailAddress', type: 'required', message: 'Email Address is required.' },
            { name: 'emailAddress', type: 'pattern', message: 'Your email address has an incorrect format.' },
            { name: 'name', type: 'required', message: 'Name is required.' },
            { name: 'phone', type: 'required', message: 'Phone is required.' },
            { name: 'address', type: 'required', message: 'Street Address is required.' },
            { name: 'city', type: 'required', message: 'City is required.' },
            { name: 'state', type: 'required', message: 'State is required.' },
            { name: 'zip', type: 'required', message: 'Zip is required.' },
            { name: 'country', type: 'required', message: 'Country is required.' },
        ];

        this.dataLoaded = true;
    }
}


// WEBPACK FOOTER //
// ./src/pages/horse/horses-add-entity.component.ts